<template>
  <div class="member-wrap">
    <div v-show="!selectedMembers.length" class="select-desc">请选择要添加的成员</div>
    <div v-show="selectedMembers.length" class="select-title">已选择{{ selectedMembers.length }}个用户</div>
    <div class="member-list">
      <div v-for="(item, index) in selectedMembers" :key="`${index}${item.userid}`" :class="{'is-hover': item.isHover}" class="member-info" @mouseenter="setItemHover(index, true)" @mouseleave="setItemHover(index, false)">
        <div class="member-avatar"><img class="avatar-img" :src="item.avatar"></div>
        <div class="member-name" :title="item.name">{{ item.name }}</div>
        <div v-show="item.isHover" class="member-action" @click="onRemove(item.id)">
          <i class="el-icon-close" />
        </div>
      </div>
    </div>
    <div class="action">
      <el-button size="small" @click="onCancel()">取消</el-button>
      <el-button type="primary" size="small" :disabled="selectedMembers.length === 0" @click="onOk">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectedMemberList',
  props: {
    selectedMembers: {
      type: Array,
      default: () => Array.from({ length: 0 })
    }
  },
  methods: {
    setItemHover (index, status) {
      this.selectedMembers.forEach(t => {
        t.isHover = false
      })
      if (this.selectedMembers[index]) {
        this.selectedMembers[index].isHover = status
      }
    },
    onRemove (id) {
      const member = this.selectedMembers.find(t => t.id === id)
      const index = this.selectedMembers.findIndex(t => t.id === id)
      this.$emit('onRemoveMember', member)
      const hoverIndex = index ? index - 1 : index + 1
      this.setItemHover(hoverIndex, true)
    },
    onOk () {
      this.$emit('onOk')
    },
    onCancel () {
      this.$emit('onCancel', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../style/mixin.scss";
.member-wrap {
  float: left;
  padding-left: 25px;
  overflow: hidden;
  width: 240px;
  .select-desc {
    margin: 5px 0 10px 0;
    color: #949aae;
  }
  .select-title {
    margin: 5px 0 10px 0;
  }
  .member-list {
    height: 375px;
    margin-bottom: 15px;
    overflow: auto;
  }
  .member-info {
    position: relative;
    display: flex;
    line-height: 40px;
    height: 40px;
    padding: 0 10px;
    margin-right: 5px;
    &.is-hover {
      background: #fafcff;
      cursor: default;
    }
    @import '../style/member-avatar.scss';
    .member-name {
      width: 135px;
      position: relative;
      @include textOverflow;
    }
    .member-action {
      position: absolute;
      right: 7px;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .action {
    float: right;
  }
}
</style>
